var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-bg poc"},[(_vm.isGifShow)?_c('elem',{attrs:{"mode":_vm.getElemBg}}):_vm._e(),_c('div',{staticClass:"bg poc",style:(_vm.getStaticBg)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }